import cn from "classnames";
import { Switch as AriaSwitch } from "react-aria-components";

export interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  ariaLabel?: string;
}

export const Switch = ({
  checked,
  onChange,
  disabled,
  className,
  children,
  ariaLabel,
}: SwitchProps) => {
  return (
    <AriaSwitch
      aria-label={ariaLabel}
      isSelected={checked}
      onChange={onChange}
      isDisabled={disabled}
      className={cn(
        "group flex items-center gap-2",
        "text-sm font-medium text-black",
        "data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed",
        className,
      )}
    >
      {/* Switch track */}
      <div
        className={cn(
          "relative inline-flex h-6 w-11 items-center rounded-[99px]",
          "transition-colors duration-200 ease-in-out",
          "bg-black-300",
          "group-data-[selected]:bg-blue-500",
          "group-data-[disabled]:bg-indigo-200",
          "group-data-[disabled]:cursor-not-allowed",
        )}
      >
        {/* Switch thumb */}
        <span
          className={cn(
            "inline-block h-4 w-4 transform bg-white rounded-[99px]",
            "transition-transform duration-200 ease-in-out",
            "translate-x-1",
            "group-data-[selected]:translate-x-6",
          )}
        />
      </div>
      {children && <span>{children}</span>}
    </AriaSwitch>
  );
};
